window.$ = window.jQuery = require('jquery');
import toastr from 'toastr';
var Root = require("./root");
var root = new Root();

(function () {
    var $body = $("body");
    $body.on("click", ".btn-favorito", function (e) {
        e.preventDefault();
        var $btn = $(this);
        var $icono = $btn.find("i.fa");
        var slug = $btn.attr("data-slug");
        $.ajax({
            url: root.base + "/productos/agregar-favorito/" + slug,
            type: "GET",
            cache: false,
            success: function(r) {
                if(r.error === true) {
                    toastr.error(r.mensaje);
                } else {
                    toastr.success(r.mensaje);
                }

                $btn.removeClass("btn-favorito").addClass("btn-favorito-eliminar");
                $icono.removeClass("fa-heart-o").addClass("fa-heart");
            },
            error: function (jqXHR) {
                toastr.error(jqXHR.responseText);
            },
            beforeSend: function() {
                $("#cargador").show();
            },
            complete: function() {
                $("#cargador").hide();
            }
        });
    });

    $body.on("click", ".btn-favorito-eliminar", function (e) {
        e.preventDefault();
        var $btn = $(this);
        var $icono = $btn.find("i.fa");
        var slug = $btn.attr("data-slug");
        $.ajax({
            url: root.base + "/productos/eliminar-favorito/" + slug,
            type: "GET",
            cache: false,
            success: function(r) {
                if(r.error === true) {
                    toastr.error(r.mensaje);
                } else {
                    toastr.success(r.mensaje);
                }
                $btn.removeClass("btn-favorito-eliminar").addClass("btn-favorito");
                $icono.removeClass("fa-heart").addClass("fa-heart-o");
            },
            error: function (jqXHR) {
                toastr.error(jqXHR.responseText);
            },
            beforeSend: function() {
                $("#cargador").show();
            },
            complete: function() {
                $("#cargador").hide();
            }
        });
    });
})();